import React from "react";
import {
    I2cRadioButton,
    I2cRadioGroup,
    I2cCheckboxGroup,
    I2cListItem,
    I2cCheckbox,
    I2cTooltip, 
    I2cIcon,
    I2cInput,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { cardPlacement, cardChannelAll, secondaryCardOption, shareBalance, ownProfile,
} from "./stringUtils";
const CardOrderPlacementAndSecondaryCard = ({ control, handleValueChanges, methods, errors }) => {
    
    const handleCardPlacementCheckboxChange = (value) => {
        let updatedSelectedOptions = [
            ...(methods.getValues("pf_card_placement") ?? []),
        ];
        if (updatedSelectedOptions.includes(value)) {
            // If the option is already selected, remove it
            updatedSelectedOptions = updatedSelectedOptions.filter(
                (item) => item !== value,
            );
        } else {
            // If the option is not selected, add it
            updatedSelectedOptions.push(value);
        }
        
        // Store as array to support multi-selection
        // Note: For API submission, transform using formatCardPlacementForAPI() 
        // to maintain backward compatibility (single value if length === 1, array if > 1)
        methods.setValue("pf_card_placement", updatedSelectedOptions);
        methods.trigger();
        handleValueChanges();
    };

    const handleIndividualsCheckboxGroupChange = (event) => {
        let selectedOptions;
        if (!event.length) selectedOptions = event.target.value;
        else selectedOptions = event;
        let updatedSelectedOptions = [
            ...(methods.getValues("pf_card_placement_channel") ?? []),
        ];
        if (updatedSelectedOptions.includes(selectedOptions)) {
            // If the card is already selected, remove it
            updatedSelectedOptions = updatedSelectedOptions.filter(
                (card) => card !== selectedOptions,
            );
            // If "other" is deselected, clear the other input field
            if (selectedOptions === "other") {
                methods.setValue("pf_card_placement_channel_other", "");
            }
        } else {
            // If the card is not selected, add it
            updatedSelectedOptions.push(selectedOptions);
        }
        methods.setValue("pf_card_placement_channel", updatedSelectedOptions);
        methods.trigger();
        if (updatedSelectedOptions.length)
            methods.clearErrors("pf_card_placement_channel");
        else
            methods.setError("pf_card_placement_channel", {
                message: "At least one source must be selected",
            });
    }; 
    return (
        <React.Fragment>
            <div i2c-grid="grid gap-sm" className="section-space">
                <div i2c-grid="12">
                    <span slot="label" className="organize-tooltip">
                        <div className="sub-heading">How Cards will be ordered?</div>
                        <I2cTooltip
                            content="Procedure through which customers will request to order a card and the subsequent channels used to place requests to i2c Inc."
                            placement="right-start"
                        >
                            <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
                        </I2cTooltip>
                    </span>
                </div>
                <div i2c-grid="12">
                    <I2cCheckboxGroup
                        className="full-list"
                        name="cn_card_option"
                    >
                        <div i2c-grid="grid gap-sm">
                            {cardPlacement.map((option, index) => (
                                <I2cListItem
                                    key={index}
                                    i2c-grid="6@md"
                                    variant="receipt"
                                    label={option.label}
                                    style={{ display: "flex", justifyContent: "space-between" }}
                                    sublabel=""
                                    className="option-container cardlist-custom-direction"
                                    checked={
                                        methods.watch("pf_card_placement")?.includes(option.value) ?? false
                                    }
                                    type="checkbox"
                                    onI2cCheckboxClicked={(e) => {
                                        handleCardPlacementCheckboxChange(option.value);
                                    }}
                                >
                                    <I2cCheckbox
                                        slot="prefix"
                                        filled
                                        checked={
                                            methods.watch("pf_card_placement")?.includes(option.value) ?? false
                                        }
                                        name="cardOption"
                                        value={option.value}
                                    ></I2cCheckbox>
                                    <I2cTooltip
                                        slot="suffix"
                                        hoist
                                        content={option.supportText}
                                        placement="right-start"
                                    >
                                        <I2cIcon
                                            color="#A1A3AE"
                                            name="cs-linear-help-circle"
                                        ></I2cIcon>
                                    </I2cTooltip>
                                </I2cListItem>
                            ))}
                        </div>
                    </I2cCheckboxGroup>
                </div>
                <div i2c-grid="12">
                    <div className="custom-label-light mb-16">
                        Select the channels
                    </div>
                    <div className="single-field-wrapper">
                        <Controller
                            name="pf_card_placement_channel"
                            control={control}
                            render={({ field }) => (
                                <I2cCheckboxGroup
                                    {...field}
                                    className="centeredCheckbox"
                                    label=""
                                >
                                    <div i2c-grid="grid gap-sm">
                                        {cardChannelAll.map((card, index) => (
                                            <I2cListItem
                                                key={index}
                                                i2c-grid="6@md"
                                                variant="receipt"
                                                label={card.label}
                                                sublabel=""
                                                value=""
                                                type="checkbox"
                                                checked={
                                                    methods
                                                        .watch("pf_card_placement_channel")
                                                        ?.includes(card.value) ?? false
                                                }
                                                onI2cCheckboxClicked={(e) => {
                                                    handleIndividualsCheckboxGroupChange(card.value);
                                                    handleValueChanges();
                                                }}
                                            >
                                                <I2cCheckbox
                                                    slot="prefix"
                                                    filled
                                                    value={card.value}
                                                    checked={
                                                        methods
                                                            .watch("pf_card_placement_channel")
                                                            ?.includes(card.value) ?? false
                                                    }
                                                    className="customCheckbox"
                                                ></I2cCheckbox>
                                            </I2cListItem>
                                        ))}
                                    </div>
                                </I2cCheckboxGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.pf_card_placement_channel &&
                                    methods.formState.touchedFields.pf_card_placement_channel
                                    ? true
                                    : false
                            }
                            message={
                                errors.pf_card_placement_channel?.message ?? "Invalid input"
                            }
                        />
                    </div>
                </div>
                {methods.watch("pf_card_placement_channel")?.includes("other") && (
                    <div i2c-grid="6@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="pf_card_placement_channel_other"
                                control={control}
                                render={({ field }) => (
                                    <I2cInput
                                        {...field}
                                        label="Please specify other channel"
                                        placeholder="Enter Channel Name"
                                        size="large"
                                        value={methods.watch("pf_card_placement_channel_other") ?? ""}
                                        onI2cInput={(e) => {
                                            field.onChange(e.target.value);
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                    />
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.pf_card_placement_channel_other &&
                                        methods.formState.touchedFields.pf_card_placement_channel_other
                                        ? true
                                        : false
                                }
                                message={
                                    errors.pf_card_placement_channel_other?.message ?? "Invalid input"
                                }
                            />
                        </div>
                    </div>
                )}
            </div>
            <div i2c-grid="grid gap-sm" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">Secondary/Supplementary Cards</div>
                </div>
                <div i2c-grid="6@md">
                    <I2cRadioGroup
                        label="Are secondary/supplementary cards permitted?"
                        onI2cChange={(e) => {
                            methods.setValue(
                                "pf_supplimentary_cards_permitted",
                                e.target.value,
                            );
                            if (e.target.value === "no" || e.target.value === "n/a") {
                                const arr = [
                                    "supplimentary_cards_own_profile",
                                    "supplimentary_cards_share_primary_balance",
                                ];
                                arr.forEach((field) => methods.setValue(field, ""));
                            }
                            methods.trigger();
                            handleValueChanges();
                        }}
                        value={methods.watch("pf_supplimentary_cards_permitted")}
                    >
                        {secondaryCardOption.map((radio, index) => (
                            <I2cRadioButton
                                key={index}
                                value={radio.toLocaleLowerCase()}
                                label={radio}
                            >
                                {radio}
                            </I2cRadioButton>
                        ))}
                    </I2cRadioGroup>
                </div>
                <div i2c-grid="6@md">
                    <I2cRadioGroup
                        label="Is the seconday supplementary card 18+?"
                        onI2cChange={(e) => {
                            methods.setValue(
                                "pf_supplimentary_cards_age_limit",
                                e.target.value,
                            );
                            methods.trigger();
                            handleValueChanges();
                        }}
                        value={methods.watch("pf_supplimentary_cards_age_limit")}
                    >
                        {secondaryCardOption.map((radio, index) => (
                            <I2cRadioButton
                                key={index}
                                value={radio.toLocaleLowerCase()}
                                label={radio}
                            >
                                {radio}
                            </I2cRadioButton>
                        ))}
                    </I2cRadioGroup>
                </div>
                {methods.watch("pf_supplimentary_cards_permitted") === "yes" && (
                    <>
                        <div i2c-grid="6@md">
                            <I2cRadioGroup
                                label="Will the secondary cards have their own profile?"
                                onI2cChange={(e) => {
                                    methods.setValue(
                                        "supplimentary_cards_own_profile",
                                        e.target.value,
                                    );
                                    methods.trigger();
                                    handleValueChanges();
                                }}
                                value={methods.watch("supplimentary_cards_own_profile")}
                            >
                                {ownProfile.map((radio, index) => (
                                    <I2cRadioButton
                                        key={index}
                                        name="pf_ownProfile"
                                        value={radio.toLocaleLowerCase()}
                                        label={radio}
                                        checked={
                                            methods.watch("supplimentary_cards_own_profile") ===
                                            radio.toLocaleLowerCase()
                                        }
                                    >
                                        {radio}
                                    </I2cRadioButton>
                                ))}
                            </I2cRadioGroup>
                        </div>
                        <div i2c-grid="6@md">
                            <I2cRadioGroup
                                label="If Yes, will they share balance with the Primary Card?"
                                onI2cChange={(e) => {
                                    methods.setValue(
                                        "supplimentary_cards_share_primary_balance",
                                        e.target.value,
                                    );
                                    methods.trigger();
                                    handleValueChanges();
                                }}
                                value={methods.watch(
                                    "supplimentary_cards_share_primary_balance",
                                )}
                            >
                                {shareBalance.map((radio, index) => (
                                    <I2cRadioButton
                                        key={index}
                                        value={radio.toLocaleLowerCase()}
                                        label={radio}
                                        checked={
                                            methods.watch(
                                                "supplimentary_cards_share_primary_balance",
                                            ) === radio.toLocaleLowerCase()
                                        }
                                    >
                                        {radio}
                                    </I2cRadioButton>
                                ))}
                            </I2cRadioGroup>
                        </div>
                    </>
                )}
            </div>
        </React.Fragment>
    );
};

export default CardOrderPlacementAndSecondaryCard;
